import React from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from './style';

const Row = ({ children, selected }) => (
  <StyledRow selected={selected}>{children}</StyledRow>
);

Row.propTypes = {
  children: PropTypes.node.isRequired,
  selected: PropTypes.bool
};

Row.defaultProps = {
  selected: false
};

export default Row;
